import {configuration} from './Configuration'
import {addAuthHeader} from './SiteConfig-api'
import ScadaObject from '../model/ScadaObject'
import axios from 'axios'

export const loadObjects = (
  marketKey: string,
  siteKey: string,
  type: string
): Promise<ScadaObject[]> =>
  loadObjectsFromURL(`${configuration.DowntimeAPI(marketKey)}object/${siteKey}/${type}`, marketKey)

const loadObjectsFromURL = (url: string, marketKey: string): Promise<ScadaObject[]> => {
  return new Promise(async function (resolve, reject) {
    axios
      .get(url, {
        withCredentials: true,
        headers: await addAuthHeader('DowntimeApi', marketKey)
      })
      .then(function (response) {
        resolve(response.data)
        console.log(response)
      })
      .catch(function (error) {
        reject(error.response ? error.response.statusText : error.message)
        console.log(error)
      })
  })
}

export const loadTypes = (marketKey: string, siteKey: string): Promise<string[]> =>
  loadTypesFromURL(`${configuration.DowntimeAPI(marketKey)}objecttype/${siteKey}`, marketKey)

const loadTypesFromURL = async (url: string, marketKey: string): Promise<string[]> => {
  return new Promise(async function (resolve, reject) {
    axios
      .get(url, {
        withCredentials: true,
        headers: await addAuthHeader('DowntimeApi', marketKey)
      })
      .then(function (response) {
        resolve(response.data)
        console.log(response)
      })
      .catch(function (error) {
        reject(error.response ? error.response.statusText : error.message)
        console.log(error)
      })
  })
}
